import { UserDataStatus } from "./user-data-status";
import { UserDataType } from "./user-data-type";

export class AddFileUserDataRequest {
  fileId: number | null = 0;
  status: UserDataStatus | null = null;
  type: UserDataType | null = null;
  message: string | null = null;

  constructor(init?: Partial<AddFileUserDataRequest>) {
    Object.assign(this, init);
  }
}
